export const isVideo = (contentType) => !!contentType.match(/^video\/.+/)
